import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Candidate|Exams|Attributes|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateExamAttributes';
export type SPCandidateExamAttributesLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelCatName`
	| `${LocNameStart}LabelValue`;

export const spCandidateExamAttributesLocs: LocDefs<SPCandidateExamAttributesLocNames> = {
	SPCandidateExamAttributesTitlePage: {
		defaultValue: 'Exam Attributes',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Exam/CandidateExamAttributes.Title.ExamAttributes',
		...sharedProperties,
	},
	SPCandidateExamAttributesTitleTab: {
		defaultValue: 'Attributes',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Exam/CandidateExamAttributes.Title.Tab',
		...sharedProperties,
	},
	SPCandidateExamAttributesLabelCatName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Title',
		legacyName: 'Exam/CandidateExamAttributes.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateExamAttributesLabelValue: {
		defaultValue: 'Value',
		description: 'Column heading for: Value.',
		displayPath: `${pathStart}Value`,
		displayType: 'Title',
		legacyName: 'Exam/CandidateExamAttributes.ColumnHeading.Value',
		...sharedProperties,
	},
};

export type SPCandidateExamAttributesLocType = LocMap<SPCandidateExamAttributesLocNames>;
